export default __webpack_public_path__ + "static/13-1ea87b52327a635cf6c11433a4ee85ed.png";